<template>
  <fragment>
    <slot></slot>
    <b-loading
      :is-full-page="false"
      :active.sync="isPending"
      :can-cancel="true"
    ></b-loading>
  </fragment>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'WsExamPermissions',
  props: {
    exam: Object
  },
  data () {
    return {
      isPending: true
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole', 'resourcesPermissions']),
    ...mapGetters('authentication', ['getUserGuid']),
    isNotMainExamExpert () {
      return this.currentRole === 'front_me' && this.exam.main_expert.guid !== this.getUserGuid
    },
    isNotTechnicalExamExpert () {
      const isTechnicalExamExpert = this.findExpert(this.exam.technical_experts || [])
      return this.currentRole === 'front_tech_expert' && !isTechnicalExamExpert
    },
    isNotExamExpert () {
      const isExamExpert = this.findExpert(this.exam.experts || [])
      return this.currentRole === 'front_le' && !isExamExpert
    }
  },
  methods: {
    findExpert (experts = []) {
      return Boolean(experts.find(exp => exp.guid === this.getUserGuid))
    }
  },
  created () {
    const admin = this.resourcesPermissions && this.resourcesPermissions['admin']
    const isAdmin = admin ? admin.length > 0 : false

    if (this.isNotMainExamExpert || this.isNotTechnicalExamExpert || this.isNotExamExpert) {
      if (!isAdmin) {
        this.isPending = true
        window.location.replace('/demo-exams')
      } else {
        this.isPending = false
      }
    } else {
      this.isPending = false
    }
  }
}

</script>
